export const WEEKLY_BENCH_TITLE = 'Weekly Bench Report';

const today = new Date();
const selectedDate = [
  today.getFullYear(),
  String(today.getMonth() + 1).padStart(2, '0'),
  String(today.getDate()).padStart(2, '0'),
].join('-');

const globalFilter = (field, header, item) => ({
  field,
  header,
  visible: false,
  filter: true,
  sortable: false,
  pinnable: false,
  defaultPinned: false,
  showPinButtonInHeader: false,
  showFilterButtonInHeader: false,
  isGlobalFilter: true,
  menuItems: [{ label: header, items: [{ type: 'filter', field, label: header, ...item }] }],
});

export const weeklyBenchFilters = [
  globalFilter('selectedDate', 'Date', {
    template: 'dayCalendar',
    placeholder: 'Select Date',
    calendarOverlayConfig: { panelClassName: 'custom-calendar-panel' },
    selectedValue: selectedDate,
    selectedValues: [selectedDate],
  }),
  globalFilter('sections', 'Sections', {
    template: 'multiSelect',
    placeholder: 'Select Sections',
    selectedValues: [WEEKLY_BENCH_TITLE],
    options: [{ label: WEEKLY_BENCH_TITLE, value: WEEKLY_BENCH_TITLE }],
  }),
];

export const weeklyBenchColumns = [
  {
    field: 'employeeDetails',
    header: 'Employee Details',
    width: 240,
    format: {
      type: 'nested',
      template: [{ field: 'name' }, { field: 'vertical' }],
    },
  },
  { field: 'employeeEmail', header: 'Employee Email', width: 240 },
  { field: 'employeeDesignation', header: 'Employee Designation', width: 220 },
  { field: 'resourceType', header: 'Resource Type', width: 180 },
  { field: 'allocation', header: 'Allocation %', width: 130 },
  { field: 'fte', header: 'FTE Equivalent', width: 140 },
  { field: 'startDate', header: 'Start Date', width: 140 },
  { field: 'endDate', header: 'End Date', width: 140 },
  { field: 'benchAge', header: 'Bench Age (Days)', width: 150 },
  { field: 'skills', header: 'Skills', width: 240, ellipsis: true },
  { field: 'remarks', header: 'Remarks', width: 240, ellipsis: true },
].map((column) => ({
  ...column,
  visible: true,
  filter: false,
  sortable: false,
  pinnable: false,
  defaultPinned: false,
  showPinButtonInHeader: false,
  showFilterButtonInHeader: false,
  numeric: ['allocation', 'fte', 'benchAge'].includes(column.field),
}));

export const defaultWeeklyBenchAppliedFilters = weeklyBenchFilters.map(({ field, menuItems }) => {
  const { selectedValue = null, selectedValues = [] } = menuItems[0].items[0];
  return { field, selectedValue, selectedValues, value: selectedValue ?? selectedValues };
});

// Filters live in the Staffing MIS toolbar, so drop them from the report table columns.
export const handleWeeklyBenchResponse = (response) => {
  const report = response.data?.weeklyBench || response.data || response;
  const columns = (report.tableConfiguration || weeklyBenchColumns)
    .filter((column) => !column.isGlobalFilter)
    .map((column) => {
      const isEllipsisField = ['skills', 'remarks'].includes(column.field);
      return {
        ...column,
        ...(isEllipsisField ? { ellipsis: true } : {}),
        pinnable: false,
        defaultPinned: false,
        showPinButtonInHeader: false,
      };
    });
  response.tableConfiguration = columns;
  if (response.data) response.data.tableConfiguration = response.tableConfiguration;
};

